import { useSelector } from "react-redux";

import { StoreType } from "../../../../utils/types";

export const SHIFT_CHANGE_MENU_ITEM_ID = 83;
export const SHIFT_CHANGE_REQUESTS_PATH = "/worker-requests-shift-change";

// Shift change requests need Full Time Scheduling, so the page and the drawer
// item are offered only to supervisors with an FT-scheduling location. The
// token carries no per-location shift change flag yet, so a location with FT
// scheduling on but shift change off still sees the (empty) page.
const useIsShiftChangeAvailable = () => {
	const ftSchedulerEnabled = useSelector(
		(state: StoreType) => state.user.userData.ftSchedulerEnabled
	);
	const ftSchedulerEnabledLocations = useSelector(
		(state: StoreType) => state.user.userData.ftSchedulerEnabledLocations
	);
	return (
		Boolean(ftSchedulerEnabled) && (ftSchedulerEnabledLocations?.length ?? 0) > 0
	);
};

export default useIsShiftChangeAvailable;
